export class FormulaGrammar
{
    //
    // SpreadsheetML Spec
    // https://msdn.microsoft.com/en-us/library/ff533995(v=office.12).aspx
    //
    // Formula book (PDF)
    // http://bagmeijer.com/Artikelen/Excel_Formulas.pdf
    //
    // Sample Formulas:
    // http://ewbi.blogs.com/develops/2004/12/excel_formula_p.html
    // app/controllers.ui.spreadsheets/data/grid/formula/grammar.ohm
    //
    public static GrammarContent = require('@mintdata-wsp/common/controllers/spreadsheet/formula/engine/formula-grammar.ohm').default;
}
